import { c as _c } from "react/compiler-runtime";
import { FormSummary, VStack } from "@navikt/ds-react";
import { useBehovContextState } from "@/app/(behov)/[behovId]/state/contextState";
import { formatFnr } from "@/utils/formatting";
import { UiSelector } from "@/utils/uiSelectors";
export function Summary() {
  const $ = _c(30);
  const {
    submittedData,
    handleEdit,
    lederInfo
  } = useBehovContextState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>Nærmeste leder for</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = lederInfo.sykmeldt.fullnavn;
  let t2;
  if ($[1] !== lederInfo.sykmeldtFnr) {
    t2 = formatFnr(lederInfo.sykmeldtFnr);
    $[1] = lederInfo.sykmeldtFnr;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${t1} (${t2})`;
  let t4;
  if ($[3] !== t3) {
    t4 = <FormSummary.Header><VStack gap="space-8">{t0}<FormSummary.Heading level="3">{t3}</FormSummary.Heading></VStack></FormSummary.Header>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FormSummary.Label>Fødselsnummer til nærmeste leder</FormSummary.Label>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== submittedData.leder.fodselsnummer) {
    t6 = formatFnr(submittedData.leder.fodselsnummer);
    $[6] = submittedData.leder.fodselsnummer;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <FormSummary.Answer>{t5}<FormSummary.Value>{t6}</FormSummary.Value></FormSummary.Answer>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FormSummary.Label>Etternavn</FormSummary.Label>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== submittedData.leder.etternavn) {
    t9 = <FormSummary.Answer>{t8}<FormSummary.Value>{submittedData.leder.etternavn}</FormSummary.Value></FormSummary.Answer>;
    $[11] = submittedData.leder.etternavn;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FormSummary.Label>E-post</FormSummary.Label>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== submittedData.leder.epost) {
    t11 = <FormSummary.Answer>{t10}<FormSummary.Value>{submittedData.leder.epost}</FormSummary.Value></FormSummary.Answer>;
    $[14] = submittedData.leder.epost;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FormSummary.Label>Mobilnummer</FormSummary.Label>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== submittedData.leder.mobilnummer) {
    t13 = <FormSummary.Answer>{t12}<FormSummary.Value>{submittedData.leder.mobilnummer}</FormSummary.Value></FormSummary.Answer>;
    $[17] = submittedData.leder.mobilnummer;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t11 || $[20] !== t13 || $[21] !== t7 || $[22] !== t9) {
    t14 = <FormSummary.Answers>{t7}{t9}{t11}{t13}</FormSummary.Answers>;
    $[19] = t11;
    $[20] = t13;
    $[21] = t7;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== handleEdit) {
    t15 = <FormSummary.Footer><FormSummary.EditLink onClick={handleEdit} className="cursor-pointer" /></FormSummary.Footer>;
    $[24] = handleEdit;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t4) {
    t16 = <FormSummary data-testid={UiSelector.BehovSummary}>{t4}{t14}{t15}</FormSummary>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t4;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}